import { DeliveryItemsByPeriod, ProductQuantitiesChange } from '../../models';

export default function (
  sourceShopItems: DeliveryItemsByPeriod,
  toShop: string,
) {
  const changes: ProductQuantitiesChange[] = [];
  Object.entries(sourceShopItems).forEach(([deliveryPeriod, deliveryItems]) => {
    Object.entries(deliveryItems.items ?? {}).forEach(
      ([productId, deliveryItem]) => {
        changes.push({
          productId,
          accountAddressKey: toShop,
          quantity: deliveryItem.quantity,
          note: deliveryItem.note,
          deliveryPeriod,
        });
      },
    );
  });
  return changes;
}
